import MultiplayerMenu from '../../components/games/shared/MultiplayerMenu.vue';
import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';

const PAUSE_STATE = 'paused';

export default {
    mounted() {
        if (this.paramsArray && this.paramsArray.length > 1) {
            this.currentPlayersAmount = this.paramsArray.length;
        }
    },
    data() {
        return {
            checkMultiplayerAnswers: false,
            commonParametersChangerCounter: 0,
            currentPlayersAmount: 0,
            multiplayerGamesState: PAUSE_STATE,
            refreshGameEvent: false,
            playAgainReadyScreens: 0,
            checkAnswersReadyScreens: 0,
            readyForAnswerPlayers: [],
            continueGameEvent: false,
        };
    },
    methods: {
        handlePlayersAmountChange(eventData) {
            if (this.multiplayerGamesState !== PAUSE_STATE) {
                return;
            }
            this.currentPlayersAmount = eventData.amount;
            let newParamsArray = this.paramsArray;
            let difference = this.currentPlayersAmount - this.paramsArray.length;
            if (difference <= 0) {
                newParamsArray.length = this.currentPlayersAmount;
            } else {
                let defaultGameSettings = cloneDeep(
                    !this.sameSettingsAreActive ? eventData.commonParameters : this.paramsArray[0]
                );
                for (let i = 0; i < difference; i++) {
                    defaultGameSettings.playerName = `${this.$i18n.t('common.common_userType_player')} ${this
                        .paramsArray.length + 1}`;
                    newParamsArray.push(cloneDeep(defaultGameSettings));
                }
            }
            this.$store.dispatch('setParamsArray', newParamsArray);
        },
        handleCommonParametersChange(parameter) {
            if (this.multiplayerGamesState !== PAUSE_STATE) {
                return;
            }
            //calling each 'Main' game component function to update current games parameters and set them to vuex
            this.handleCurrentGameParametersChange(parameter);
            this.commonParametersChangerCounter += 1;
        },
        handleGameStateChange(state) {
            this.multiplayerGamesState = state;
        },
        invokeRefreshGameEvent() {
            this.refreshGameEvent = !this.refreshGameEvent;
            this.playAgainReadyScreens = 0;
            this.checkAnswersReadyScreens = 0;
        },
        invokeContinueGameEvent() {
            this.continueGameEvent = true;
            this.$nextTick(() => {
                this.continueGameEvent = false;
            });
        },
        invokeCheckAnswersEvent() {
            if (!this.isCheckAnswersReady) {
                return;
            }
            this.checkMultiplayerAnswers = true;
            this.$nextTick(() => {
                this.checkMultiplayerAnswers = false;
                this.checkAnswersReadyScreens = 0;
            });
        },
        handleCheckAnswersReadyEvent({ status, playerPosition }) {
            if (status) {
                if (!this.readyForAnswerPlayers.includes(playerPosition)) {
                    this.checkAnswersReadyScreens += 1;
                    this.readyForAnswerPlayers.push(playerPosition);
                }
            } else {
                this.checkAnswersReadyScreens -= 1;
                let playerIndex = this.readyForAnswerPlayers.indexOf(playerPosition);
                if (playerIndex >= 0) {
                    this.readyForAnswerPlayers.splice(playerIndex, 1);
                }
            }
        },
    },
    computed: {
        ...mapState({
            paramsArray: state => state.trainer.paramsArray,
        }),
        isCheckAnswersReady() {
            return (
                this.isContinueGameReady &&
                this.arePlayersReadyToAnswer &&
                this.playAgainReadyScreens !== this.currentPlayersAmount
            );
        },
        isContinueGameReady() {
            return this.multiplayerGamesState !== PAUSE_STATE;
        },
        arePlayersReadyToAnswer() {
            return !!this.readyForAnswerPlayers.length;
        },
    },
    components: {
        MultiplayerMenu,
    },
};
